module.exports = __webpack_public_path__ + "static/twister-christmas-c37b92a3c4dd1418603a667cba177159.jpg";